import type { FaireProductEntity } from "../../entity_types/product";

export const p_knwydze7fm: FaireProductEntity = {
  token: "p_knwydze7fm",
  type: "product",
  name: "Assorted Happy Birthday Boxed Card Set - Greeting Cards",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/0eb605197a1b780aaa3298599d3905de86c5194cf12cb8d1ce05be8b655e8f36.png",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/86db89168d4ea94f75c95f3f49342b7232271b5dc15cfe6477ec7a76b0012bad.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
